import { render, staticRenderFns } from "./DropdownToggle.vue?vue&type=template&id=7809937f&scoped=true"
import script from "./DropdownToggle.vue?vue&type=script&lang=js"
export * from "./DropdownToggle.vue?vue&type=script&lang=js"
import style0 from "./DropdownToggle.vue?vue&type=style&index=0&id=7809937f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7809937f",
  null
  
)

export default component.exports